 document.addEventListener("DOMContentLoaded", (event) => {


  let hdrElement = document.querySelector('#site-control .links');
  if (hdrElement) {
    var hdrDiv = document.createElement('div');
    hdrDiv.classList.add('header-bar');
    hdrDiv.innerHTML = '<div><a href="tel:201.770.9950">201.770.9950</a></div><div><a href="tel:8883727363">888.372.7363</a></div>';
    hdrElement.parentNode.insertBefore( hdrDiv, hdrElement.previousSibling );
  } else {
    //console.error('Header element not found.');
  }

  let btnElement = document.querySelector('.template-product .cc-tabs__tab__panel h3:last-child a');
  if (btnElement) {
    btnElement.classList.add('button'); 
  } else {
    //console.error('Button not found.');
  }

  let ftrBtnElement = document.querySelector('.section-footer__text-block p');
  if (ftrBtnElement) {
    ftrBtnElement.insertAdjacentHTML('afterend', '<a class="button" href="/pages/quoterequest">Request a Quote</a>'); 
  } else {
    //console.error('Footer element not found.');
  }

   
});